import { apiGetHelper } from '../../helperFunctions'

export const searchAirports = async (searchString: string, origin?: string) => {
    // const response = await new Promise((resolve, reject) => {
    //     setTimeout(() => {
    //         resolve({
    //             data: [
    //                 {
    //                     priority: 1,
    //                     nearby: false,
    //                     text: 'Belgrade',
    //                     score: 26,
    //                     payload: {
    //                         airportId: 'BEGAll',
    //                         airportCode: 'BEG',
    //                         weight: 12,
    //                         cityId: '55905',
    //                         provinceId: '45086',
    //                         cityName: 'Belgrade',
    //                         airportName: 'All Airports',
    //                         countryName: 'Serbia',
    //                         countryCode: 'RS',
    //                         countryMisspell: '',
    //                         cityMisspell: '',
    //                         score: 26.056402
    //                     }
    //                 },
    //                 {
    //                     priority: 1,
    //                     nearby: false,
    //                     text: 'Bella Bella',
    //                     score: 10,
    //                     payload: {
    //                         airportId: 'ZEL',
    //                         airportCode: 'ZEL',
    //                         weight: 4,
    //                         cityId: '117979',
    //                         provinceId: '43075',
    //                         cityName: 'Bella Bella',
    //                         airportName: 'Denny Island Aerodrome',
    //                         countryName: 'Canada',
    //                         countryCode: 'CA',
    //                         countryMisspell: '',
    //                         cityMisspell: '',
    //                         score: 10.466507
    //                     }
    //                 },
    //                 {
    //                     priority: 1,
    //                     nearby: false,
    //                     text: 'Bloomington (IL)',
    //                     score: 10,
    //                     payload: {
    //                         airportId: 'BMI',
    //                         airportCode: 'BMI',
    //                         weight: 4,
    //                         cityId: '141766',
    //                         provinceId: '45905',
    //                         cityName: 'Bloomington (IL)',
    //                         airportName: 'Central Illinois Regional Airport at Bloomington-Normal',
    //                         countryName: 'United States',
    //                         countryCode: 'US',
    //                         countryMisspell: '',
    //                         cityMisspell: '',
    //                         score: 10.396755
    //                     }
    //                 },
    //                 {
    //                     priority: 1,
    //                     nearby: false,
    //                     text: 'Block Island',
    //                     score: 10,
    //                     payload: {
    //                         airportId: 'BID',
    //                         airportCode: 'BID',
    //                         weight: 4,
    //                         cityId: '62211',
    //                         provinceId: '45865',
    //                         cityName: 'Block Island',
    //                         airportName: 'Block Island State Airport',
    //                         countryName: 'United States',
    //                         countryCode: 'US',
    //                         countryMisspell: '',
    //                         cityMisspell: '',
    //                         score: 10.30383
    //                     }
    //                 },
    //                 {
    //                     priority: 1,
    //                     nearby: false,
    //                     text: 'Bullhead City',
    //                     score: 10,
    //                     payload: {
    //                         airportId: 'IFP',
    //                         airportCode: 'IFP',
    //                         weight: 4,
    //                         cityId: '51349',
    //                         provinceId: '45859',
    //                         cityName: 'Bullhead City',
    //                         airportName: 'Laughlin/Bullhead City Airport',
    //                         countryName: 'United States',
    //                         countryCode: 'US',
    //                         countryMisspell: '',
    //                         cityMisspell: '',
    //                         score: 10.30383
    //                     }
    //                 }
    //             ]
    //         })
    //     }, 1000)
    // })

    // do/search  predictive search url check
    try {
        const response = await apiGetHelper({
            URL: `${origin ? origin : ''}/predictive/${searchString}?q=${searchString}`,
            deviceType: 'DESKTOP'
        })
        if (origin){
            return (response as any).data || []
        }
        return response
    } catch (error) {
        console.error('Error searching airports:', error)
        return []
    }
}
